import { render } from "./RootInput.vue?vue&type=template&id=fc76f2cc&ts=true&lang=pug"
import script from "./RootInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./RootInput.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__